import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import moment from 'moment';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';

import { Report } from '~/components';
import { DateTime, Autocomplete, Input, RadioGroup } from '~/components/Form';

import { GFO, GFU, GPP } from '~/constants/perfil';

import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';

function Relrecebimento() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS
  const [valueOrgao, setValueOrgao] = React.useState('');
  const [inputValueOrgao, setInputValueOrgao] = React.useState('');

  const [valuePosto, setValuePosto] = React.useState('');
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [valueProduto, setValueProduto] = React.useState('');
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  // const start = moment()
  //   .subtract({ day: 7 })
  //   .set({ hour: 0, minute: 0, second: 0 });

  // const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );


  const { profile } = useSelector((state) => state.user);

  const [disableOrgao, setDisableOrgao] = useState(false);
  const [disablePosto, setDisablePosto] = useState(false);
  const [postoRequired, setPostoRequired] = useState(false);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        // datahorainicial: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),
        // datahorafinal: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value), 'Data invalida')
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),

        placa: Yup.string()
          .nullable()
          .max(7, t('s.geral.validacao.tamanhomaximo').replace('%s', 7)),
        nf: Yup.string()
          .nullable()
          .max(30, t('s.geral.validacao.tamanhomaximo').replace('%s', 30)),
        usuresp: Yup.string()
          .nullable()
          .max(20, t('s.geral.validacao.tamanhomaximo').replace('%s', 20)),
        distribuidora: Yup.string()
          .nullable()
          .max(15, t('s.geral.validacao.tamanhomaximo').replace('%s', 15)),
        transportadora: Yup.string()
          .nullable()
          .max(15, t('s.geral.validacao.tamanhomaximo').replace('%s', 15)),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (profile.glousuariotipo === GFO || profile.glousuariotipo === GFU) {
        setValueOrgao(profile.glousuarioorgacodigo);
        setDisableOrgao(true);
      } else if (profile.glousuariotipo === GPP) {
        setValuePosto(profile.glousuariopostocodigo);
        setDisablePosto(true);
      }
    }

    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let posto = '';

    if (params.poco_codigo) {
      posto = params.poco_codigo;
    }

    let postostr = '';

    if (params.poco_desc_abrev) {
      postostr = params.poco_desc_abrev;
    }

    let orgao = '';

    if (params.orga_codigo) {
      orgao = params.orga_codigo;
    }

    let orgaostr = '';

    if (params.orga_nome) {
      orgaostr = params.orga_nome;
    }

    let produto = '';

    if (params.prod_codigo) {
      produto = params.prod_codigo;
    }

    let produtostr = '';

    if (params.prod_descricao) {
      produtostr = params.prod_descricao;
    }

    let placa = '';

    if (params.placa) {
      placa = params.placa;
    }

    let nf = '';

    if (params.nf) {
      nf = params.nf;
    }

    let usuresp = '';

    if (params.usuresp) {
      usuresp = params.usuresp;
    }

    let distribuidora = '';

    if (params.distribuidora) {
      distribuidora = params.distribuidora;
    }

    let transportadora = '';

    if (params.transportadora) {
      transportadora = params.transportadora;
    }

    // deixa produto apenas para compor o filtro
    let pedido = '';

    let tipo = 'pdf';

    if (params.formato) {
      tipo = params.formato;
    }

    return {
      ...params,
      datahorainicial,
      datahorafinal,
      posto,
      postostr,
      produto,
      produtostr,
      orgao,
      orgaostr,
      placa,
      pedido,
      nf,
      usuresp,
      distribuidora,
      transportadora,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Descargas"
      relatorio="DESCARGAS"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        // datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        // datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),        
        datahorainicial,
        datahorafinal,
        orga_codigo: valueOrgao,
        poco_codigo: valuePosto,
      }}
    >
      <DateTime
        label="Data Inicial"
        name="datahorainicial"
        serialize={(value) =>
          value.set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
        disableFuture
      // serialize={(value) =>
      //   moment(value).set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss')
      // }
      // showTime
      />

      <DateTime
        label="Data Final"
        name="datahorafinal"
        serialize={(value) =>
          value.set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
        disableFuture
        invalidDateMessage={''}
        minDateMessage={''}
        maxDateMessage={''}
      // serialize={(value) =>
      //   moment(value).set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss')
      // }
      // showTime
      />

      <Autocomplete
        name="orga_codigo"
        label="orga_nome"
        title="Órgão"
        id="orga_codigo"
        url="orgaos"
        unique="orga_codigo"
        value={valueOrgao}
        inputValue={inputValueOrgao}
        onChange={(event, newValue) => {
          setValueOrgao(newValue);
        }}
        onInputChange={(event, newInputValueOrgao) => {
          setInputValueOrgao(newInputValueOrgao);
        }}
        defaultValue=""
        hiddens={[{ name: 'orga_nome' }]}
        getValue={(value) => {
          if (value.orga_codigo !== null) {
            setValueOrgao(value.orga_codigo);
          } else {
            setValueOrgao('');
          }
        }}
        disabled={disableOrgao}
      />

      <Autocomplete
        name="poco_codigo"
        label="poco_desc_abrev"
        title="Posto"
        id="poco_codigo"
        url="postoscomboios"
        unique="poco_codigo"
        value={valuePosto}
        inputValue={inputValuePosto}
        onChange={(event, newValue) => {
          setValuePosto(newValue);
        }}
        onInputChange={(event, newInputValuePosto) => {
          setInputValuePosto(newInputValuePosto);
        }}
        defaultValue=""
        hiddens={[{ name: 'poco_desc_abrev' }]}
        getValue={(value) => {
          if (value.poco_codigo !== null) {
            setValuePosto(value.poco_codigo);
          } else {
            setValuePosto('');
          }
        }}
        disabled={disablePosto}
      />

      <Autocomplete
        name="prod_codigo"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProtudo) => {
          setInputValueProduto(newInputValueProtudo);
        }}
        defaultValue=""
        hiddens={[{ name: 'prod_descricao' }]}
        getValue={(value) => {
          if (value.prod_codigo !== null) {
            setValueProduto(value.prod_codigo);
          } else {
            setValueProduto('');
          }
        }}
      />

      <Input name="placa" label="Placa CT" />
      <Input name="nf" label="Nota Fiscal" />
      <Input name="usuresp" label="Usuário" />
      <Input name="distribuidora" label="Distribuidora" />
      <Input name="transportadora" label="Transportadora" />

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relrecebimento;
